var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoin11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9848 14.248C18.1712 15.3184 13.6325 13.2632 8.87968 9.66646C4.12687 6.06974 0.915504 2.25892 1.72905 1.18847C2.54259 0.118012 7.0385 2.17329 11.8341 5.77001C16.5869 9.36673 19.7983 13.1775 18.9848 14.248Z",
    fill: "url(#paint0_linear_1_281)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2143 13.4773C17.4864 14.4193 13.4187 12.5782 9.09409 9.3668C4.81228 6.11262 1.94347 2.68718 2.67138 1.74518C3.39929 0.760365 7.46701 2.60153 11.7488 5.85571C16.0306 9.10989 18.9423 12.4925 18.2143 13.4773Z",
    fill: "url(#paint1_linear_1_281)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6641 5.98417C7.46788 2.77281 3.48579 0.931627 2.62943 1.78799C2.65797 1.75944 2.67225 1.74518 2.67225 1.74518C3.40015 0.760365 7.46788 2.60153 11.7497 5.85571C16.0315 9.10989 18.9431 12.4925 18.2152 13.4773C18.1867 13.4773 18.1581 13.4916 18.1296 13.5202C18.729 12.4925 15.8602 9.15271 11.6641 5.98417Z",
    fill: "#A86314"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.915786 2.25874L1.72933 1.18829C0.915783 2.25874 4.12715 6.06956 8.87996 9.66628C13.6328 13.263 18.1715 15.3183 18.985 14.2478L18.1715 15.3183C17.358 16.3887 12.8192 14.3335 8.06642 10.7367C3.31361 7.14001 0.102241 3.32919 0.915786 2.25874Z",
    fill: "url(#paint2_linear_1_281)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_281",
    x1: 18.2569,
    y1: 16.2604,
    x2: 21.1685,
    y2: 12.4496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3912F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_281",
    x1: 12.4339,
    y1: 22.2551,
    x2: 21.597,
    y2: 10.0947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE7A22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_281",
    x1: -1.26794,
    y1: 4.91346,
    x2: 16.8013,
    y2: 18.5724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFEE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFFFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFFFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFCF5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9A5A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FFBF4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A86314"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin11);
export default __webpack_public_path__ + "static/media/coin11.d5cb352065b3a31db48e9a4ac1194836.svg";
export { ForwardRef as ReactComponent };